// src/modules/auth/pages/LoginPage.tsx

import React from 'react';
import { useAppContext } from '../../../shared/context/AppContext';
import GoogleLogin from '../components/GoogleLogin';
import SocialLinks from '../../../shared/components/ui/SocialLinks';
import Card from '../../../shared/components/ui/Card';
import Loading from '../../../shared/components/Loading';
import ErrorMessage from '../../../shared/components/ErrorMessage';
import Logo from '../../../shared/components/ui/Logo';
import './LoginPage.css';

const LoginPage: React.FC = () => {
    const { state } = useAppContext();
    const { auth } = state;

    const clearError = () => {
        // Esta función será manejada por GoogleLogin component
    };

    return (
        <div className="login-page">
            <div className="login-background">
                {/* Efectos de fondo */}
                <div className="background-pattern"></div>
            </div>

            <div className="login-container">
                <Card className="login-card">
                    {/* Logo */}
                    <div className="logo-section">
                        <div className="logo-container">
                            <Logo
                                variant="default"
                                size="lg"
                                className="main-logo"
                            />
                            <div className="logo-text">IBLOOM</div>
                        </div>
                    </div>

                    {/* Contenido principal */}
                    <div className="login-content">
                        <h1 className="login-title">Bienvenido a iBloom</h1>
                        <p className="login-subtitle">
                            Accede a nuestra plataforma para gestionar tu negocio de manera eficiente y segura
                        </p>

                        {/* Estado de carga */}
                        {auth.isLoading && (
                            <div className="loading-section">
                                <Loading message="Verificando acceso..." />
                            </div>
                        )}

                        {/* Mensaje de error */}
                        {auth.error && (
                            <div className="error-section">
                                <ErrorMessage
                                    message={auth.error}
                                    onClose={clearError}
                                />
                            </div>
                        )}

                        {/* Componente de Google Login */}
                        {!auth.isLoading && (
                            <div className="google-login-section">
                                <GoogleLogin />
                            </div>
                        )}

                        {/* Términos y condiciones */}
                        <div className="terms-section">
                            <p className="terms-text">
                                Al ingresar, aceptas nuestros términos y condiciones
                            </p>
                        </div>
                    </div>

                    {/* Redes sociales */}
                    <div className="social-section">
                        <SocialLinks />
                    </div>
                </Card>
            </div>
        </div>
    );
};

export default LoginPage;